import React from 'react';
import styles from './ImgSection.module.css';

import Slide from 'react-reveal/Slide';

const ImgSection = props => (
  <section className={styles.imgSection} style={{
    flexDirection: `${props.right ? 'row-reverse' : 'row'}`
  }}>
    <div className={styles.imgWrapperLeft}>
      {
        props.content ? (
          <Slide right>
            {props.content}
          </Slide>
          ) : (
          <Slide left={props.right ? false : true} right={props.right ? true : false }>
            <img style={{
              position: 'absolute',
              left: `${props.right ? '-60%' : '60%'}`
            }} src={props.image} alt="catfish" />
          </Slide> 
        )
      }
    </div>
    <div className={styles.description} style={props.right ? {
      marginLeft: 'none',
      marginRight: 'auto'
    } : null}>
      <div>
        {props.title ? <h1>{props.title}</h1> : null}
        <h2>{props.heading}</h2>
        <p className={styles.lead}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor</p>
        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam</p>
      </div>
    </div>
  </section>
)

export default ImgSection;